import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'synthesizeQueryController';
export default {
    /**
     * 综合查询-查询案件流转记录
     */
    queryCaseTurnRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseTurnRecord',
        type: requestType.Get
    },
    /**
     * 综合查询-委外案件查询
     */
    queryCaseOutRecords: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseOutRecords',
        type: requestType.Get
    },
    /**
     * inbound查询
     */
    inBoundQuery: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'inBoundQuery',
        type: requestType.Get
    },
    /**
     * 锁定催收员
     */
    bindLockingCollector: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'bindLockingCollector',
        type: requestType.Get
    },
    /**
     * 短信记录查询
     */
    queryMessageSendRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryMessageSendRecord',
        type: requestType.Get
    },
    /**
     * 实时还款查询
     */
    queryRepaymentRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryRepaymentRecord',
        type: requestType.Get
    },
    /**
     * 还款总金额查询
     */
    getTotalRepayment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getTotalRepayment',
        type: requestType.Get
    },
    /**
     * 策略分案数据查询列表
     */
    queryCaseDistributeData: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'queryCaseDistributeData',
        type: requestType.Get
    },
    /**
     * 案件查询
     */
    caseSearch: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseSearch',
        type: requestType.Get
    },
    /**
     * 案件导出
     */
    caseSearchExportCase: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseSearchExportCase',
        type: requestType.Get
    },
    /**
     * 催记导出
     */
    caseSearchExportFollow: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseSearchExportFollow',
        type: requestType.Get
    },
    /**
     * 查询案件状态
     */
    getCaseCollectionStatus: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCaseCollectionStatus',
        type: requestType.Get
    }
};
